import { render } from "./TopNavigationBarView.vue?vue&type=template&id=4e12ee49"
import script from "./TopNavigationBarView.vue?vue&type=script&lang=js"
export * from "./TopNavigationBarView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__